// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.holidaySelection {
  margin-top: 16px;
}
.holidaySelection input {
  opacity: 100;
  height: 20px;
  width: 20px;
  position: relative;
  bottom: 4px;
}
.holidaySelection .title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.holidaySelection .optionContainer {
  display: flex;
  align-content: space-between;
}
.holidaySelection .optionContainer .baseOptions {
  display: inline-block;
}
.holidaySelection .optionContainer .secondaryOptions {
  margin: auto;
  display: inline-block;
}
.holidaySelection .optionContainer .secondaryOptions .optionLabel {
  position: relative;
  left: 30px;
  bottom: 27px;
}
.holidaySelection .optionContainer .ternaryOptions {
  margin: auto;
  position: relative;
  left: 6px;
  bottom: 6px;
}
.holidaySelection .optionContainer .ternaryOptions .optionLabel {
  position: relative;
  left: 6px;
  bottom: 6px;
  display: inline-block;
}
.holidaySelection .optionContainer .ternaryOptions .customInputWrapper {
  display: inline-block;
  border-bottom: 1px solid black;
  position: relative;
  bottom: 6px;
  left: 17px;
  width: 80px;
}
.holidaySelection .optionContainer .ternaryOptions .customInputWrapper .customInput {
  display: inline-block;
  border: none;
  width: 40px;
  position: relative;
  top: 0.5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.holidaySelection .optionContainer .ternaryOptions .customInputWrapper .unit {
  display: inline-block;
  position: relative;
  left: 8px;
  top: 1px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #333333;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/screens/workContractModification/holidaySelection/holidaySelection.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AACR;AAEI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAEI;EACI,aAAA;EACA,4BAAA;AAAR;AACQ;EACI,qBAAA;AACZ;AACQ;EACI,YAAA;EACA,qBAAA;AACZ;AAAY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAEhB;AACQ;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AACZ;AAAY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAEhB;AACY;EACI,qBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAChB;AAAgB;EACI,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAEpB;AAAgB;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAEpB","sourcesContent":[".holidaySelection {\n    margin-top: 16px;\n\n    input {\n        opacity: 100;\n        height: 20px;\n        width: 20px;\n        position: relative;\n        bottom: 4px;\n    }\n\n    .title {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n    .optionContainer {\n        display: flex;\n        align-content: space-between;\n        .baseOptions {\n            display: inline-block;\n        }\n        .secondaryOptions {\n            margin: auto;\n            display: inline-block;\n            .optionLabel {\n                position: relative;\n                left: 30px;\n                bottom: 27px;\n            }\n        }\n        .ternaryOptions {\n            margin: auto;\n            position: relative;\n            left: 6px;\n            bottom: 6px;\n            .optionLabel {\n                position: relative;\n                left: 6px;\n                bottom: 6px;\n                display: inline-block;\n            }\n\n            .customInputWrapper {\n                display: inline-block;\n                border-bottom: 1px solid black;\n                position: relative;\n                bottom: 6px;\n                left: 17px;\n                width: 80px;\n                .customInput {\n                    display: inline-block;\n                    border: none;\n                    width: 40px;\n                    position: relative;\n                    top: 0.5px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 16px;\n                    line-height: 24px; \n                    color: #333333;\n                }\n                .unit {\n                    display: inline-block;\n                    position: relative;\n                    left: 8px;\n                    top: 1px;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    text-align: right;\n                    color: #333333;\n                    text-align: right;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
